import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AutoCompleteResult, isNullOrUndefined } from '@uzurv/core';
import { Location, LocationService, MapsService } from '@uzurv/clara';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-location-search-input',
  templateUrl: './location-search-input.component.html',
  styleUrls: ['./location-search-input.component.scss']
})
export class LocationSearchInputComponent {

  @Input() placeholder = 'Search Locations';

  @Input() displayFavoriteLocationIcon = false;

  @Input() autocompleteThreshold = 5;

  @Input() disabled = false;

  @Input() postSelectedLocationToApi = false;

  @Output() locationSelectedHandler: EventEmitter<Location> = new EventEmitter<Location>();

  @Output() favoriteLocationSelectedHandler: EventEmitter<any> = new EventEmitter<any>();

  @Output() blurHandler: EventEmitter<any> = new EventEmitter<any>();

  @Output() focusHandler: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('locationSearchForm', { static: true }) locationSearchForm: NgForm;

  @ViewChild('locationSearchInput', { static: true }) locationSearchInput: ElementRef;

  searching = false;

  searchQuery: string;

  searchResults: Array<AutoCompleteResult>;

  private displaySuggestions: (predictions, status) => void;

  constructor(
    private mapsService: MapsService,
    private dialog: MatDialog,
    private locationService: LocationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  onKeyUp(event) {
    this.searching = false;

    if (!isNullOrUndefined(this.searchQuery) && this.searchQuery.length > this.autocompleteThreshold && this.searchQuery.length % 2 === 0) {
      this.performSearch(true);
    }
  }

  onBlur() {
    this.blurHandler.emit();
  }

  onFocus() {
    this.focusHandler.emit();
  }

  setText(text: string) {
    this.searchQuery = text;
  }

  setFocused() {
    this.locationSearchInput.nativeElement.focus();
    setTimeout(() => this.locationSearchInput.nativeElement.focus(), 500);
  }

  resetResults() {
    this.searchResults = null;
  }

  performSearch(isAutocomplete = false) {
    if (isNullOrUndefined(this.searchQuery)) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          title: 'No Search Query',
          message: 'Please enter a search query'
        }
      });
      return;
    }

    this.searching = !isAutocomplete;

    this.mapsService.autocomplete(this.searchQuery).subscribe(results => (this.searchResults = results));
  }

  favoriteLocationSelectionClicked() {
    this.favoriteLocationSelectedHandler.emit();
  }

  selectSearchResult(searchResult: AutoCompleteResult) {
    // TODO: This should justnemit the selected search result and the saving/geocoding should be handled by the parent component.

    if (this.postSelectedLocationToApi) {
      this.locationService.addLocation(searchResult.label).subscribe(
        location => {
          this.locationSelectedHandler.emit(location);
          this.searchResults = null;
          this.searchQuery = searchResult.label;
          this.changeDetectorRef.detectChanges();
        },
        err => {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'Error',
              message: err.message
            }
          });
        }
      );
    } else {
      this.mapsService.geocodeLocationByAutoCompleteResult(searchResult).subscribe(
        location => {
          this.locationSelectedHandler.emit(location);
          this.searchResults = null;
          this.searchQuery = searchResult.label;
          this.changeDetectorRef.detectChanges();
        },
        err => {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'Error',
              message: err.message
            }
          });
        }
      );
    }
  }
}
